<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-2"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-left pa-1">
        <div class="layout-row">
          <lx-btn small classes="mr-1" :disabled="false"
                  @click="getDataForTable()"
                  icon="refresh" :tooltip="$t('LIST_DIVERSE.REFRESH')" :label="$t('buttons.refresh.value')"
                  :hide-label="true"></lx-btn>
          <lx-btn small classes="mr-1" :disabled="false"
                  @click="addTabToStore({routeName: 'CancerRegisterNew', options: {icon: 'mdi-new-box', headline: $t('COMPONENT_REGISTER.NEW_REGISTER'),label: {text: $t('LIST_DIVERSE.UNSAVED')}}})"
                  icon="mdi-home-plus" :tooltip="$t('COMPONENT_REGISTER.ADD_NEW_REGISTER_TOOLTIP')"
                  :label="$t('COMPONENT_REGISTER.ADD_NEW_REGISTER')"
                  :hide-label="true"></lx-btn>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background" style="overflow-y: hidden">
        <lx-data-table
          tableName="CancerRegisterList"
          v-model="tableObj.selection"
          :items="items"
          :headers="tableObj.headers"
          :loading="tableObj.loading"
          :tableOptions="tableObj.options"
          :hideContextFilter="true"
          @changeOptions="changeTableOptions"
          @rowClicked="openRegisterDetails">

          <template #cellrenderer="{ value }">
            <div v-if="value.f.renderer === 'delete'"
                 style="cursor:pointer;"
                 class="layout-align-center-start">
              <v-icon :color="compColor.primeColor" @click="openDeleteDialog(value.i, $event)">mdi-delete-forever</v-icon>
            </div>
          </template>
        </lx-data-table>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'CancerRegisterList'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable">
        </lx-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import LxPagination from "../../../components/lx_pagination/LxPagination"

export default {
  name: 'CancerRegisterList',
  data () {
    return {
      tableObj: {
        loading: false,
        options: {
          sortBy: ['name'],
          sortDesc: [false],
        },
        selection: [],
        headers: [
          {
            text: '',
            width: '20px',
            renderer: 'delete'
          },
          {
            text: 'Id',
            value: 'id',
            width: '250px',
            sortable: true
          },
          {
            text: this.$t('COMPONENT_REGISTER.NAME'),
            value: 'name',
            width: '300px',
            class: 'pinned',
            sortable: true
          },
          {
            text: this.$t('COMPONENT_REGISTER.INST_ID'),
            value: 'installation_id',
            width: '200px',
            sortable: true
          }
        ]
      },
      pagingOptions: {
        limit: 50,
        skip: 0,
        count: 0
      },
      items: [],
      selectedListEntry: null,
      listSelectionList: [],
      deleteDialogTitle: this.$t('CONFIRM_DELETE_DIALOG.HEADER'),
      deleteDialogMessage: this.$t('CONFIRM_DELETE_DIALOG.MESSAGE_DELETE_FORM'),
      deleteDialogOpts: {
        ok: this.$t('buttons.delete.value'),
        cancel: this.$t('buttons.cancel.value')
      }
    }
  },
  components: {
    LxPagination
  },
  created () {
    this.getDataForTable()
  },
  methods: {
    /**
     * Open Dialog to confirm or decline delete of selected cancer registers
     */
    openDeleteDialog (params, event) {
      if (event) {
        event.stopPropagation()
      }

      this.DialogConfirm(
        this.deleteDialogTitle,
        this.deleteDialogMessage,
        this.deleteDialogOpts)
        .then(() => {
          if (params && params.id) {
            this.$http.delete('/register/' + params.id)
              .then(res => {
                this.removeTabIfDatasetWasDeleted({
                  routeName: 'CancerRegisterDetails',
                  routeParams: { registerId: params.id }
                })

                this.NotifySuccess(res, 'Der Datensatz wurde erfolgreich gelöscht.')
                this.getDataForTable()
              })
              .catch(this.NotifyError)
          }
        })
        .catch(() => {
        })
    },

    /**
     * React on changes of options in lx-data-table, set table-options in component and call getDataForTable
     */
    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    /**
     * Open new tab with selected cancer register
     */
    openRegisterDetails (params) {
      if (params && params.id) {
        this.addTabToStore({
          routeName: 'CancerRegisterDetails',
          routeParams: { registerId: params.id },
          options: {
            headline: this.$t('COMPONENT_REGISTER.REGISTER_SHORT_NAME') + ' ' + params.name
          }
        })
      }
    },

    /**
     * Get all cancer registers from db
     */
    getDataForTable (options) {
      if (this.tableObj.loading) return

      this.tableObj.loading = true

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = '{}'

      this.$http.get('/register?config={"opts":' + JSON.stringify(opts) + ', "query": ' + query + ', "count":true}')
        .then(res => {
          if (res.data) {
            this.items = res.data.result
            this.$set(this.tableObj, 'selection', [])

            this.pagingOptions.count = res.data.count || 0
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'CancerRegisterList') {
        this.getDataForTable()
      }
    }
  }
}
</script>
